export default __webpack_public_path__ + "static/media/kredit-hero.e49fc379.jpg";